import React, { createContext, useContext, useMemo } from 'react';
import { useProjectActions } from '../hooks/useProjectActions';

export const ProjectContext = createContext(null);

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};

export const ProjectProvider = ({ children, projectVariant, projectType }) => {
  const actions = useProjectActions(projectVariant, projectType);

  const value = useMemo(() => ({ projectVariant, projectType, actions }), [projectVariant, projectType, actions]);

  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
};
